import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HorizontalFulfillmentGaugeData } from '../../../../dashboards/components/horizontal-fulfillment-gauge/horizontal-fulfillment-gauge.component';
import { GaugeChartData } from '../../../../dashboards/components/gauge-chart/gauge-chart.component';
import { FeedbackDashboardItem, FeedbackQuestionScores } from '../../../../_models/feedback-dashboard/feedback-dashboard.model';
import { LineChartData } from '../../../../dashboards/components/line-chart/line-chart.component';

@Component({
    selector: 'dashboard-main-item-section',
    templateUrl: './dashboard-main-item-section.component.html',
    styleUrls: ['./dashboard-main-item-section.component.css'],
    standalone: false
})
export class DashboardMainItemSectionComponent implements OnInit, OnChanges {
  @Input() feedbackDashboardItem: FeedbackDashboardItem = new FeedbackDashboardItem();

  public gaugeChartData: GaugeChartData = new GaugeChartData();
  public lineChartData: Array<LineChartData> = new Array<LineChartData>();
  public scoresList: Array<HorizontalFulfillmentGaugeData> = new Array<HorizontalFulfillmentGaugeData>();

  constructor() { }

  ngOnInit() {
    this.calculateChartData();
  }

  ngOnChanges(): void {
    this.calculateChartData();
  }

  private calculateChartData(): void {
    this.gaugeChartData.percentage = this.feedbackDashboardItem.dashboardScorePercentage;
    this.gaugeChartData.subText = this.feedbackDashboardItem.dashboardScoreSubText;

    this.scoresList = new Array<HorizontalFulfillmentGaugeData>();
    this.lineChartData = new Array<LineChartData>();
    if(this.feedbackDashboardItem) {
      if (this.feedbackDashboardItem.feedbackQuestionScoreList) {
        this.feedbackDashboardItem.feedbackQuestionScoreList.forEach(score => {
          this.scoresList.push({header: score.questionScoreHeaderText, value: score.questionScorePercentage});
        });
      }
      if (this.feedbackDashboardItem.feedbackTimeSeriesData && this.feedbackDashboardItem.feedbackTimeSeriesData.feedbackDataPoints) {
        this.feedbackDashboardItem.feedbackTimeSeriesData.feedbackDataPoints.forEach(point => {
          this.lineChartData.push({label: point.label, value: point.value});
        });
      }
    }

    
  }
}
